export var WORKFLOW_TYPES;
(function (WORKFLOW_TYPES) {
  WORKFLOW_TYPES["ACTIVATION"] = "ACTIVATION";
  WORKFLOW_TYPES["CANCELLATION"] = "CANCELLATION";
  WORKFLOW_TYPES["PLAN_MODIFICATION"] = "PLAN_MODIFICATION";
  WORKFLOW_TYPES["SUSPEND"] = "SUSPEND";
  WORKFLOW_TYPES["SWOP_MODEM"] = "SWOP MODEM";
})(WORKFLOW_TYPES || (WORKFLOW_TYPES = {}));